import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { closePopover } from '../../actions/popover'
import { hideTimelineInjection } from '../../actions/timeline_injections'
import PopoverLayout from './popover_layout'
import List from '../list'

class TimelineInjectionOptionsPopover extends React.PureComponent {

  handleOnClick = () => {
    this.props.onDismissInjection()
    this.props.onDismiss()
    this.props.onClosePopover()
  }

  handleOnClosePopover = () => {
    this.props.onClosePopover()
  }

  render() {
    const { isXS } = this.props

    return (
      <PopoverLayout
        width={280}
        isXS={isXS}
        onClose={this.handleOnClosePopover}
      >
        <List
          size={isXS ? 'large' : 'small'}
          scrollKey='timeline_injection_options'
          items={[{
            hideArrow: true,
            title: 'Show this content less often',
            onClick: this.handleOnClick,
          }]}
        />
      </PopoverLayout>
    )
  }
}

const mapDispatchToProps = (dispatch, { timelineInjectionId }) => ({
  onDismissInjection() {
    dispatch(hideTimelineInjection(timelineInjectionId))
  },
  onClosePopover: () => dispatch(closePopover()),
})

TimelineInjectionOptionsPopover.propTypes = {
  isXS: PropTypes.bool,
  timelineInjectionId: PropTypes.string.isRequired,
  onClosePopover: PropTypes.func.isRequired,
  onDismissInjection: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
}

export default connect(null, mapDispatchToProps)(TimelineInjectionOptionsPopover)